module.exports = __webpack_public_path__ + "images/FUSA_icons/084-package.a4ee38e3ce8da273700834200978c322.svg";